// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__+pXbz","date":"_styles_date__PraeC"};